import { emptyApi } from "./emptyApi";

type SubmitAIQuestionCardResponse = {
  status: string;
  message: string;
  message_id: string;
  card_status: string;
};

type SubmitAIQuestionCardArgs = {
  groupId: string;
  messageId: string;
  customType: string;
  metadata: Record<string, unknown>;
};

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    submitAIQuestionCard: build.mutation<
      SubmitAIQuestionCardResponse,
      SubmitAIQuestionCardArgs
    >({
      query: ({ groupId, messageId, customType, metadata }) => ({
        url: `/api/inkle/messaging/group/${groupId}/message/${messageId}/ai-question-card/submit/`,
        method: "PATCH",
        body: { custom_type: customType, metadata },
      }),
      invalidatesTags: ["AI_ONBOARDING"],
    }),
  }),
});

export const { useSubmitAIQuestionCardMutation } = extendedApi;
